var FuseShortcutsModule = /** @class */ (function () {
    function FuseShortcutsModule() {
    }
    return FuseShortcutsModule;
}());
export { FuseShortcutsModule };
